function normalizeRole(value) {
  return String(value || '').trim().toLowerCase();
}

/**
 * Instructor = active staff of an active organisation (the server's
 * `access.org.role`), or a platform admin (global role `admin`).
 *
 * The old global `teacher` / `instructor` roles and `user_type` are not read:
 * no code assigns them, and the server's staff routes check the membership.
 *
 * @param {object|null|undefined} user
 * @returns {boolean}
 */
export function isInstructorAccount(user) {
  if (normalizeRole(user?.role) === 'admin') return true;
  return user?.access?.org?.role === 'staff';
}
